<div class="card border-0 marketplace-admin-card-custom shadow-cards h-100" (mouseleave)="leaveCard(p)" (mouseenter)="enterCard(p)"
    [ngClass]="product.hasModifiedHighlight ? 'backingHighlight' : ''" (click)="edit(product);">

    <!-- Img prod -->
    <div class="overflow-hidden position-relative text-center card-img-container"
        [ngClass]="[product.PointStoreProductAllAssignments.attr.length > 0 ? 'attribute-filter-img' : '', product.ProductImageID == 0 ? 'not-available-container': '']">
        <div [ngClass]="product.PointStoreProductAllAssignments.attr.length > 0 ? 'attribute-assigned-overlay' : ''">
        </div>

        <img cvImageFallback
            [svgIcon]="'../App_Themes/CXone/icons/gamification/cannot-load-image.svg#cannot-load-image'"
            [svgClass]="'icon-65'" [spanText]="cannotLoadImgText()"
            [spanClass]="'text-uppercase font-weight-700 font-size-10 color-grey-base position-absolute image-not-available'"
            [bgContainer]="'bg-alice-blue-shadow'"
            *ngIf="product.ProductImageID > 0 || baseCardService.isMainImageEmptyWithMultiplesImages(product); else imageNotAvailable"
            cvLocalizedText langSection="MarketPlace_Management" langKey="Image_Not_Available" alt="Image Not Available"
            [ngClass]="product.ProductImageID == 0 ? '' : 'card-img-top-custom'"
            [src]="product.ProductImageID > 0 ? '../Admin/ImageResizer.aspx?imgid=' + product.ProductImageID + '&w=auto&h=155' 
                                              : '../Admin/ImageResizer.aspx?imgid=' + product.MultipleImagesData[0].PointStoreProductImageID + '&w=auto&h=155'" loading="lazy" />
        <ng-template #imageNotAvailable>
            <svg class="icon-46">
                <use href="../App_Themes/CXone/icons/gamification/image-not-available.svg#image-not-available"></use>
            </svg>
        </ng-template>

        <span cvLocalizedText langSection="MarketPlace_Management" langKey="Image_Not_Available"
            class="text-uppercase font-weight-700 font-size-10 color-grey-base position-absolute image-not-available"
            *ngIf="product.ProductImageID == 0 && !baseCardService.isMainImageEmptyWithMultiplesImages(product)">Image Not
            Available</span>

    </div>
    <span *ngIf="product.PointStoreProductAllAssignments.attr.length > 0" cvLocalizedText
        langSection="MarketPlace" langKey="Attribute_Assigned"
        class="font-weight-400 font-size-12 color-interface position-absolute text-center py-2 overflow-hidden  attribute-assigned-container">Attribute
        assigned</span>
    <!-- end img prod -->

    <!-- dropdown menu -->
    <div class="custom-dropdown d-inline-block dropdown position-absolute mt-2">
        <button id="productOperations" type="button" class="border-0" placement="bottom right" #pop="bs-popover"
            [adaptivePosition]="false" containerClass="prodOpcContainer" [popover]="productOperationsContainer"
            triggers="click" [outsideClick]="true" (click)="$event.stopPropagation(); setCurrentPopover(pop)">
            <div class="d-flex align-items-center">
                <svg class="icon-16 fill-grey">
                    <use href="../App_Themes/CXone/icons/dropdown.svg#dropdown"></use>
                </svg>
            </div>
        </button>
        <ng-template #productOperationsContainer>
            <div id="productOperationsContainer">
                <div id="editproductcontainer" ngbDropdownItem class="d-flex align-items-center"
                    [ngClass]="!baseCardService.hasPermission('WRITE') ? 'opacity-5 cursor-default' : ''"
                    (click)="!baseCardService.hasPermission('WRITE') ? $event.stopPropagation() : edit(product); $event.stopPropagation();pop.hide()">
                    <svg class="icon-16 fill-grey mb-1 mr-1">
                        <use href="../App_Themes/CXone/icons/gamification/edit-item.svg#edit-item"></use>
                    </svg>
                    <span id="editproduct" cvLocalizedText langSection="MarketPlace_Management_Product_Operation"
                        langKey="Edit_Product"
                        class="py-2 px-2 font-size-13 line-height-18 font-weight-400 color-black">Edit</span>
                </div>
                <div id="copyproductcontainer" ngbDropdownItem class="d-flex align-items-center"
                    [ngClass]="!baseCardService.hasPermission('CREATE') ? 'opacity-5 cursor-default' : ''"
                    (click)="!baseCardService.hasPermission('CREATE') ? $event.stopPropagation() : copy(product); $event.stopPropagation();pop.hide()">
                    <svg class="icon-16 fill-grey mb-1 mr-1">
                        <use href="../App_Themes/CXone/icons/duplicate.svg#duplicate"></use>
                    </svg>
                    <span id="copyproduct" cvLocalizedText langSection="MarketPlace_Management_Product_Operation"
                        langKey="Duplicate_Product"
                        class="py-2 px-2 font-size-13 line-height-18 font-weight-400 color-black">Duplicate</span>
                </div>
                <div id="removeproductcontainer" ngbDropdownItem class="d-flex align-items-center"
                    [ngClass]="!baseCardService.hasPermission('WRITE') ? 'opacity-5 cursor-default' : ''"
                    (click)="!baseCardService.hasPermission('WRITE') ? $event.stopPropagation() : remove(product); $event.stopPropagation();pop.hide()">
                    <svg class="icon-16 fill-grey mb-1 mr-1">
                        <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
                    </svg>
                    <span id="deleteproduct" cvLocalizedText langSection="MarketPlace_Management_Product_Operation"
                        langKey="Delete_Product"
                        class="py-2 px-2 font-size-13 line-height-18 font-weight-400 color-black">Delete</span>
                </div>
            </div>
        </ng-template>
    </div>
    <!-- end dropdown menu -->
    <div class="card-body py-2 p-09 landing-card-body"
        [ngClass]="displayFlexColumn(product) ? 'lcb-expanded' : 'lcb-normal'">
        <div class="d-flex justify-content-between">
            <!-- title card -->
            <h5 id="card-title"
                class="card-title color-black font-weight-600 text-truncate font-size-15 line-height-20 pr-4 my-auto font-weight-600">
                {{product.Title}}
            </h5>
            <!-- end title card -->
            <!-- icon to collapse more info about product -->
            <span id="infoproduct" [ngbPopover]="collapsecontainer" #p="ngbPopover" [class.active]="p.isOpen()" placement="bottom-right top-right top-left left right" container="body" triggers="manual" (mouseover)="openPopover(p)">
                <svg class="icon-16 fill-grey">
                    <use href="../App_Themes/CXone/icons/info.svg#info"></use>
                </svg>
            </span>
            <!-- end icon collapse -->

            <!-- init collapse card -->
            <ng-template #collapsecontainer>
                <div #tooltipContainer>
                    <div id="collapse-card" class="collapse-card" (click)="$event.stopPropagation()" (mouseleave)="leavePopover(p)" (mouseenter)="changeInsidePopoverFlag()">
                        <div class="collapse-title d-flex align-items-start py-1">
                            <span
                                class="color-black font-weight-600 font-size-15 line-height-20 text-break">{{product.Title}}</span>
                        </div>
                        <div class="row py-2">
                            <div class="col-12">
                                <p cvLocalizedText langSection="MarketPlace_Management" langKey="Product_Details"
                                    class="d-flex align-items-start card-title  color-black  font-size-13 my-auto font-weight-600 line-height-18">
                                </p>
                            </div>
                        </div>
                        <div class="py-1">
                            <div class="row no-gutters">
                                <div class="col-5 ">
                                    <span class="font-size-12 color-grey font-weight-400 line-height-16" cvLocalizedText
                                        langSection="MarketPlace_Management" langKey="Category_Colon">Category:</span>
                                </div>
                                <div class="col-7"
                                    title="{{product.Category}}">
                                    <span class="font-size-12 color-darkNavy text-break font-weight-400 line-height-16">{{product.Category}}</span>
                                </div>
                            </div>
                            <div class="row no-gutters">
                                <div class="col-5">
                                    <span class="font-size-12 color-grey font-weight-400 line-height-16" cvLocalizedText
                                        langSection="MarketPlace_Management"
                                        langKey="Sub_Category_Colon">Subcategory:</span>
                                </div>
                                <div id="collapse-subcategory"
                                    class="col-7"
                                    title="{{product.SubCategory}}">
                                    <span class="font-size-12 color-darkNavy text-break font-weight-400 line-height-16">{{product.SubCategory}}</span>
                                </div>
                            </div>
                            <div class="row no-gutters">
                                <div class="col-5">
                                    <span
                                        class="font-size-12 color-grey font-weight-400 line-height-16" cvLocalizedText
                                        langSection="MarketPlace_Management"
                                        langKey="Variants_Colon">Variants:</span>
                                </div>
                                <div class="col-7"
                                    title="{{product.HasProductVariations == true ? product.VariationsData.length + ' ' + product.VariationName : (noneLabel)}}">
                                    <span class="font-size-12 color-darkNavy font-weight-400 text-break line-height-16">
                                        {{product.HasProductVariations == true ?
                                            product.VariationsData.length +
                                            ' '
                                            +
                                            product.VariationName : (noneLabel)}}
                                    </span>
                                </div>
                            </div>
                            <div class="row no-gutters">
                                <div class="col-5">
                                    <span class="font-size-12 color-grey font-weight-400 line-height-16" cvLocalizedText
                                        langSection="MarketPlace_Management" langKey="Quantity_Detail">Quantity:</span>
                                </div>
                                <div id="collapse-quantity"
                                    class="col-7">
                                    <span class="font-size-12 color-darkNavy font-weight-400 line-height-16">{{baseCardService.getProductTotalQuantity(product)}}</span>
                                    <span *ngIf="product.Quantity != null && product.ReservedQuantity != null && !product.HasProductVariations">
                                        ={{product.Quantity + product.ReservedQuantity | number}}
                                        <span class="font-size-12 color-darkNavy font-weight-400 line-height-16" cvLocalizedText langSection="MarketPlace_Management" langKey="stock">stock</span>
                                        -{{product.ReservedQuantity | number}}
                                        <span class="font-size-12 color-darkNavy font-weight-400 line-height-16" cvLocalizedTextlangSection="MarketPlace_Management" langKey="carts">cart(s)</span></span>
                                </div>
                            </div>
                            <div class="row no-gutters">
                                <div class="col-5">
                                    <span class="font-size-12 color-grey font-weight-400 line-height-16" cvLocalizedText
                                    langSection="MarketPlace_Management" langKey="Total_Ordered_Colon">Total
                                    Ordered:</span>
                                </div>
                                <div class="col-7 ">
                                    <span class="font-size-12 color-darkNavy font-weight-400 line-height-16">{{product.QuantityOrdered == null ? '0' : product.QuantityOrdered | number}}</span>
                                </div>
                            </div>
                            <div class="row no-gutters">
                                <div class="col-5">
                                    <div class="pointStoreThumbnailAssignments">
                                        <span class="font-size-12 color-grey font-weight-400 line-height-16"
                                            cvLocalizedText langSection="MarketPlace_Management"
                                            langKey="Assigned_Colon">Assigned</span>
                                    </div>
                                </div>
                                <div class="col-7">
                                    <span [hidden]="!(product.PointStoreProductAllAssignments.emp.length > 0)">
                                        <span class="font-size-12 font-weight-400 line-height-16 assigned-link" (click)="editAssigned(product);"
                                              [hidden]="product.PointStoreProductAllAssignments.empAssignAll">
                                            {{ getNumberGroupsAssigned(product) }}
                                        </span>
                                    </span>
                                    <span [hidden]="!product.PointStoreProductAllAssignments.empAssignAll">
                                        <span class="font-size-12 font-weight-400 line-height-16 assigned-link" (click)="editAssigned(product);"
                                            cvLocalizedText langSection="MarketPlace_Management_Messages"
                                            langKey="All_Groups_Assigned">All groups assigned</span>
                                    </span>
                                    <span
                                        [hidden]="!(product.PointStoreProductAllAssignments.emp.length <= 0 && !product.PointStoreProductAllAssignments.empAssignAll)">
                                        <span class="font-size-12 font-weight-400 line-height-16 assigned-link" (click)="editAssigned(product);"
                                            cvLocalizedText langSection="MarketPlace_Management_Messages" langKey="No_Groups_Assigned">No groups assigned</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="py-2" *ngIf="product.HasMultipleImages">
                            <div class="d-flex justify-content-start">
                                <div id="badge-pictures" class="badge badge-pictures">
                                    <span class="font-weight-400 font-size-13 color-black line-height-18">
                                        +{{baseCardService.getImagesCount(product)}}
                                        <ng-template [ngIf]="baseCardService.getImagesCount(product) === 1" [ngIfElse]="twoOrMorePictures">
                                            {{cvLocalizationService.getCachedText("MarketPlace_Management", "Picture", "Picture")}}
                                        </ng-template>
                                        <ng-template #twoOrMorePictures>
                                            {{cvLocalizationService.getCachedText("MarketPlace_Management", "Pictures", "Pictures")}}
                                          </ng-template>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
        <!-- end collapse card -->

        <!-- product price and date... -->
        <div class="d-flex overflow-hidden no-gutters align-items-stretch"
            [ngClass]="displayFlexColumn(product) ? 'flex-xl-column flex-lg-column ' : ''">
            <div class="col-auto mt-1">
                <span class="price-label color-grey font-size-13 font-weight-600 mr-1" cvLocalizedText
                    langSection="MarketPlace_Management" langKey="Price"></span>
            </div>
            <div class="d-flex overflow-hidden align-items-stretch no-gutters ">
                <div class="col-auto mt-coin-1">
                    <!-- coin icon -->
                    <span>
                        <svg class="icon-22">
                            <use href="../App_Themes/CXone/icons/gamification/coin.svg#coin"></use>
                        </svg>
                    </span>
                    <!-- end coin icon -->
                </div>
                <div class="col-auto">
                    <!-- real price -->
                    <div>
                        <span class="price font-size-20 font-weight-600 salePrice color-black"
                            *ngIf="!(product.Sale != null && isCurrentSale(product))" id="card-price"
                            title="{{getProductPrice(product) | cvNumberLocalize}}">{{getProductPrice(product) |
                            cvNumberLocalize}}</span>

                        <span *ngIf="product.Sale != null && isCurrentSale(product)">
                            <span id="card-price" class="price font-size-20 font-weight-600 range color-black"
                                title="{{getProductPrice(product)}}">{{getProductPrice(product) | cvNumberLocalize}}
                            </span>
                            <span *ngIf="!product.HasVariationPrices"
                                class="color-grey-base font-weight-600 font-size-15 line-height-20 line-through line-through-red text-decoration-thickness-2 real">{{product.Price
                                | cvNumberLocalize}}
                            </span>
                        </span>
                    </div>
                    <!-- end real price -->
                    <div *ngIf="product.Sale != null && isCurrentSale(product)">
                        <!-- discount -->
                        <div id="discount">
                            <span id="card-discount" *ngIf="!isCxOne"
                                [style.visibility]="!(product.Sale != null && isCurrentSale(product)) ? 'hidden' : 'visible'"
                                class="font-weight-600 font-size-15 line-height-20 color-green justify-content-end text-uppercase">({{
                                product.Sale }}% {{ offLabel }})</span>
                            <span id="card-discount" *ngIf="isCxOne" placement="bottom" triggers="mouseenter:mouseleave"
                                container="body" [popover]="salecontainer"
                                [style.visibility]="!(product.Sale != null && isCurrentSale(product)) ? 'hidden' : 'visible'"
                                class="font-weight-600 font-size-15 line-height-20 color-green justify-content-end text-uppercase">({{
                                product.Sale }}% {{ offLabel }})</span>
                        </div>
                        <!-- end discount -->
                    </div>
                </div>
            </div>

        </div>
        <!-- end product price-->

        <!-- date -->
        <div class="d-flex align-items-center py-1">
            <span id="card-date"
                title="{{formatDate(product)}}"
                class="font-size-12 color-grey-base font-weight-400 line-height-16 text-truncate">
                <span>{{formatDate(product)}}</span>
            </span>
        </div>
        <!-- end date -->

        <!-- bagdes carousel feature... -->
        <div id="badges-card" class="d-flex gap-8 py-1 landing-card-body-badges">
            <div id="carouselbagdeinfo" class="badge font-size-13 badge-carousel font-weight-400 line-height-18"
                placement="bottom" triggers="mouseenter:mouseleave" container="body" [popover]="carouselcontainer"
                [hidden]="!(product.CarouselStart != null)" [ngClass]="baseCardService.isActive(product, 'carousel')"
                cvLocalizedText langSection="MarketPlace_Management" langKey="Carousel">Carousel</div>
            <ng-template #carouselcontainer>
                <span id="card-carousel-title" style="color: #79797A !important;
												font-size: 12px;
												line-height: 16px;
												font-weight: 400;">{{getTitle(product, 'carousel')}}</span>
            </ng-template>
            <div id="featuredbagdeinfo" class="badge font-size-13 badge-featured font-weight-400 line-height-18"
                placement="bottom" triggers="mouseenter:mouseleave" container="body" [popover]="featuredcontainer"
                [hidden]="!(product.FeatureStart != null)" [ngClass]="baseCardService.isActive(product, 'featured')"
                cvLocalizedText langSection="MarketPlace_Management" langKey="Featured">Featured</div>
            <ng-template #featuredcontainer>
                <span id="card-featured-title" style="color: #79797A !important;
												font-size: 12px;
												line-height: 16px;
												font-weight: 400;">{{getTitle(product, 'featured')}}</span>
            </ng-template>
            <ng-template #salecontainer>
                <span id="card-sale-title" style="color: #79797A !important;
												font-size: 12px;
												line-height: 16px;
												font-weight: 400;">{{getTitle(product, 'sale')}}</span>
            </ng-template>
        </div>
        <!-- end bagdes carousel feature... -->
    </div>
</div>
